angular.module('app')
    .directive('newFeatureTip', function() {
        return {
            templateUrl: 'components/directives/new_feature_tip/view.new_feature_tip.html',
            controller: 'newFeatureTipController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                name: '<',
                text: '<',
                top: '<',
                right: '<',
            }
        }
    });
